"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function ThirdClause() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "thirdClause"
  }, /*#__PURE__*/_react["default"].createElement("h4", null, /*#__PURE__*/_react["default"].createElement("strong", null, "CL\xC1USULA TERCEIRA \u2013 DA CONTRATA\xC7\xC3O")), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, "3.1"), " O LICENCIADO poder\xE1 acessar os servi\xE7os englobados na contrata\xE7\xE3o atrav\xE9s do link:"));
}
var _default = ThirdClause;
exports["default"] = _default;